import React from 'react'
import './css/buttonLine.css'

const ButtonLine = ({
    text,
    onclick

}) => {
  return (
    <div>
      <button type="button" class="btn btn-custom-border" onClick={onclick}>{text}</button>
    </div>
  )
}

export default ButtonLine
